import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../../styles/styles';

const {
	colors,
	typography: { fontSizes },
	spacing,
	common,
} = THEME;

export const styleSheet = StyleSheet.create({
	isDragging: {
		opacity: 0.8,
		transform: 'rotate(2deg)',
		boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
	},
	dragHandle: {
		cursor: 'grab',
		':active': {
			cursor: 'grabbing',
		},
	},
	reordering: {
		opacity: 0.7,
		pointerEvents: 'none',
	},
	// Reorder Questions Modal styles
	board: {
		backgroundColor: colors.background.main,
		borderRadius: common.borderRadius,
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
		display: 'flex',
		flexDirection: 'column',
		maxHeight: '80vh',
		width: '650px',
		maxWidth: '90vw',
	},
	boardHeader: {
		alignItems: 'center',
		borderBottom: common.border,
		display: 'flex',
		justifyContent: 'space-between',
		padding: spacing.md,
		position: 'relative',
	},
	boardHeaderTitles: {
		flex: 1,
		textAlign: 'center',
	},
	boardHeaderTitle: {
		color: colors.text.main,
		fontSize: fontSizes.lg,
		fontWeight: 600,
		margin: 0,
	},
	boardHeaderSubheader: {
		color: colors.text.light,
		fontSize: fontSizes.sm,
		margin: `${spacing.xs}px 0 0 0`,
	},
	body: {
		flex: 1,
		overflow: 'auto',
		padding: spacing.md,
	},
	boardFooter: {
		borderTop: common.border,
		display: 'flex',
		gap: spacing.md,
		justifyContent: 'space-between',
		padding: spacing.md,
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				borderRadius: 3,
				display: 'inline-flex',
				justifyContent: 'center',
			},
			'button'
		),
	},
	columns: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	reorderQuestionItem: {
		alignItems: 'center',
		backgroundColor: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		display: 'flex',
		padding: spacing.md,
		transition: 'all 0.2s ease',
		gap: 16,
		'&:hover': {
			boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
			borderColor: colors.primary.main,
		},
	},
	reorderQuestionNumber: {
		alignItems: 'center',
		backgroundColor: colors.background.light,
		borderRadius: '50%',
		color: colors.text.main,
		display: 'flex',
		fontSize: fontSizes.sm,
		fontWeight: 600,
		height: '24px',
		justifyContent: 'center',
		minWidth: '24px',
	},
	reorderQuestionContent: {
		flex: 1,
		minWidth: 0, // Allow flex children to shrink below content size for text truncation
	},
	reorderQuestionLabel: {
		color: colors.text.main,
		fontSize: fontSizes.sm,
		fontWeight: 500,
		marginBottom: spacing.xs,
		// Truncate to single line with ellipsis
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	reorderQuestionType: {
		color: colors.text.light,
		fontSize: fontSizes.xs,
	},
	reorderQuestionDependency: {
		color: colors.primary.main,
		fontSize: fontSizes.xs,
		fontStyle: 'italic',
		marginTop: spacing.xs,
	},
	reorderQuestionDragHandle: {
		cursor: 'grab',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		':active': {
			cursor: 'grabbing',
		},
		'&:hover': {
			opacity: 0.7,
		},
	},
	modal: {},
	container: {
		display: 'flex',
		flexDirection: 'column',
		maxHeight: '80vh',
	},
});
